<template>
  <div class="pt-2 h-100">
    <div v-if="settings.appsettings && settings.appsettings.videos && settings.appsettings.videos.length >0" class="pb-2">
      <h6 class="col-12">{{$t("message.Help Videos")}} </h6>
      <div class="col-12 pb-4" v-for="video in settings.appsettings.videos" :key="video.link">
        <p class="col-12" style="font-weight: 600;">{{getTitle(video.title)}} </p>
        <div class="text-center">
          <youtube :video-id="getId(video.link)" :fitParent='true' :player-vars="playerVars" width="100%"></youtube>
        </div>
      </div>
    </div>
    <Support v-if="settings.appsettings && settings.appsettings.support && settings.appsettings.support.length >0"></Support>
    <!-- <div class="col-12">
      <card>
        <div slot="header"><span style="font-weight: 600;">Isuues</span></div>
        <div class="row">

          <div class="col-12" style="text-align: center;">
            <n-button type="primary" class="btn-padding light mr-2" round @click.native="gotoIssueTracker()">
              View tickets
            </n-button>
          </div>
        </div>
      </card>
    </div> -->
    <div v-if="settings.appsettings && settings.appsettings.support && settings.appsettings.support.length < 1 && settings.appsettings.videos && settings.appsettings.videos.length < 1">
      <div class="col-lg-12 col-md-12 col-sm-12 text-center pt-3">
        <i>{{$t("message.Help content not available")}}</i>
      </div>
      <help-videos-svg style="position: absolute; bottom: 0; max-height: 50vh; width: 100%;"></help-videos-svg>
    </div>

    <n-button type="primary" v-if="IS_ISSUE_TRACKER_ENABLED()" round size="lg" @click.native="gotoIssueTracker()" style="
                  top: auto;
                  bottom: 0px;
                  left: 50%;
                  transform: translateX(-50%);
                  position: absolute;
                  width: 15em;
                ">
      <!-- <i class="fa fa-plus pr-1"></i> -->
      <!-- {{ $t("message.New Appointment") }} -->
      {{$t("message.View or Create Tickets")}}
    </n-button>

  </div>
</template>

<script>
import Support from "./Support.vue";
import HelpVideosSvg from "./components/svg_images/HelpVideosSvg.vue";

export default {
  components: { Support, HelpVideosSvg },
  name: "help-videos",
  data() {
    return {
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
      },
    };
  },
  methods: {
    IS_ISSUE_TRACKER_ENABLED() {
      return (
        this.settings.patientAppSetting &&
        this.settings.patientAppSetting.issueTracker &&
        this.settings.patientAppSetting.issueTracker.enabled
      );
    },
    //Capitalize first letter
    getTitle(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    getId(url) {
      return this.$youtube.getIdFromUrl(url);
    },
    gotoIssueTracker() {
      this.$router.push("/issuetracker");
    },
  },
};
</script>
<style scoped>
iframe {
  border-radius: 5px;
}
</style>
